import { Controller } from "@hotwired/stimulus"

// Guards the irreversible "Delete account" form so it can't be triggered
// by accident. The submit button stays DISABLED until the user has, as
// separate deliberate steps:
//   1. ticked the acknowledgment checkbox, AND
//   2. typed their exact email address.
// Combined with the form's turbo_confirm final dialog and the server-side
// email + acknowledgment + owner checks, deleting an account takes several
// intentional actions rather than a single click.
//
// Progressive enhancement: the button ships ENABLED in the HTML and is
// disabled here on connect, so if JS never loads the server-side email
// match still guards the destructive action.
export default class extends Controller {
  static targets = ["email", "ack", "submit"]
  static values  = { email: String }

  connect() {
    // Only clamp the button down once we know JS is live to re-enable it.
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
    this.refresh()
  }

  refresh() {
    const typed = (this.hasEmailTarget ? this.emailTarget.value : "").trim().toLowerCase()
    const want  = (this.emailValue || "").trim().toLowerCase()
    const acked = this.hasAckTarget ? this.ackTarget.checked : false
    const ok    = acked && typed.length > 0 && typed === want
    if (this.hasSubmitTarget) this.submitTarget.disabled = !ok
  }
}
